import type { Block, Section } from "../types";
import ParagraphBlock from "./blocks/ParagraphBlock";
import HeadingBlock from "./blocks/HeadingBlock";
import ImageBlock from "./blocks/ImageBlock";
import ListBlock from "./blocks/ListBlock";
import CalloutBlock from "./blocks/CalloutBlock";
import StepsBlock from "./blocks/StepsBlock";
import TableBlock from "./blocks/TableBlock";

function renderBlock(block: Block, index: number) {
	switch (block.type) {
		case "paragraph":
			return <ParagraphBlock key={index} text={block.text} />;
		case "heading":
			return <HeadingBlock key={index} level={block.level} text={block.text} />;
		case "image":
			return (
				<ImageBlock
					key={index}
					src={block.src}
					alt={block.alt}
					caption={block.caption}
				/>
			);
		case "list":
			return <ListBlock key={index} ordered={block.ordered} items={block.items} />;
		case "callout":
			return <CalloutBlock key={index} kind={block.kind} text={block.text} />;
		case "steps":
			return <StepsBlock key={index} items={block.items} />;
		case "table":
			return (
				<TableBlock
					key={index}
					headers={block.headers}
					rows={block.rows}
					caption={block.caption}
				/>
			);
	}
}

interface SectionRendererProps {
	section: Section;
}

export default function SectionRenderer({ section }: SectionRendererProps) {
	return <div>{section.blocks.map(renderBlock)}</div>;
}
